import { useEffect, useState } from "react";
import api from "@/lib/api";
import { isLanderHost } from "@/lib/landerDomain";

const cache = new Map();

export function fetchLegal(kind, code) {
  const site = isLanderHost() ? window.location.hostname : "";
  const key = `${kind}:${code || ""}:${site}`;
  if (!cache.has(key)) {
    const params = { ...(code ? { b: code } : {}), ...(site ? { site } : {}) };
    const req = api.get(`/public/legal/${kind}`, { params })
      .then((r) => r.data)
      .catch((e) => { cache.delete(key); throw e; });
    cache.set(key, req);
  }
  return cache.get(key);
}

export function useLegalDoc(kind, code) {
  const [state, setState] = useState({ doc: null, error: false });
  useEffect(() => {
    let live = true;
    setState({ doc: null, error: false });
    fetchLegal(kind, code)
      .then((doc) => { if (live) setState({ doc, error: false }); })
      .catch(() => { if (live) setState({ doc: null, error: true }); });
    return () => { live = false; };
  }, [kind, code]);
  return state;
}

export function legalLinks(code) {
  const q = code ? `?b=${encodeURIComponent(code)}` : "";
  return { privacy: `/privacy${q}`, terms: `/terms${q}`, partners: `/legal-partners${q}` };
}

let contactReq = null;
// Jellis Enterprise LLC privacy contact (address, email, phone) for page footers.
export function usePublicLegalContact() {
  const [contact, setContact] = useState(null);
  useEffect(() => {
    let live = true;
    if (!contactReq) {
      contactReq = api.get("/public/legal-contact").then((r) => r.data).catch(() => { contactReq = null; return null; });
    }
    contactReq.then((c) => { if (live) setContact(c); });
    return () => { live = false; };
  }, []);
  return contact;
}

export function fmtLegalDate(iso) {
  if (!iso) return "";
  const d = new Date(`${String(iso).slice(0, 10)}T00:00:00`);
  return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
}
